import type { LinkNavTab } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

interface LessonCreateMenuReturn {
  config: ComputedRef<LinkNavTab[]>
}

/** The tabs of the legacy "Add new lesson" modal, one page each. */
export const useLessonCreateMenu = (): LessonCreateMenuReturn => {
  const route = useRoute()
  const disciplineId = route.params.id as string

  const singleUrl = resolveUrl(AppRoute.LessonsCreate, { id: disciplineId }) ?? ''
  const recurringUrl = resolveUrl(AppRoute.LessonsCreateRecurring, { id: disciplineId }) ?? ''

  const config = computed<LinkNavTab[]>(() => [
    {
      text: 'Single event',
      to: singleUrl,
      selected: route.path === singleUrl,
      disabled: false,
      visible: true,
    },
    {
      text: 'Recurring event',
      to: recurringUrl,
      selected: route.path === recurringUrl,
      disabled: false,
      // TODO(INFRA-731): recurring temporarily hidden; restore canCreateRecurring or remove entirely once decided
      visible: false,
    },
  ])

  return {
    config,
  }
}
